export default "__VITE_ASSET__DPW5aJr1__"